import React, { memo } from "react";
import styles from "@aspen/theme/Home.module.less";
import {
  GA_EVENT_NAME,
  i18nUtil,
  reportEvent,
  TRADE_PATHS,
  WALLET_PATHS,
  YIELD_PATHS,
  PUBLIC_PATHS,
} from "@aspen/libs";
import Image from "next/image";
import type { TKycLevelNumber } from "@aspen/model";
import { useRouter } from "next/router";
import { EventEntranceView } from "./DynamicImport";

interface IProps {
  showGuideModal: (level: TKycLevelNumber, isClose?: boolean) => boolean;
}

const QuickEntranceView = (props: IProps) => {
  const intl = i18nUtil.t();
  const router = useRouter();
  const handleClick = (route: string, coinCode?: string) => {
    reportEvent({ moduleName: route });
    if (coinCode) {
      router.push({ pathname: `${TRADE_PATHS.TRADE_SPOT}/${coinCode}` });
    } else {
      router.push({
        pathname: route,
      });
    }
  };
  return (
    <div className={styles.quickEentrance}>
      <div
        className={styles.entrance}
        onClick={() => {
          reportEvent({ moduleName: GA_EVENT_NAME.home.depositaCrypto });
          if (props.showGuideModal(1)) {
            handleClick(WALLET_PATHS.WALLET_DEPOSIT);
          }
        }}>
        <span className={`${styles.quickIcon} ` + `pointerNone`}>
          <Image
            unoptimized
            src={require("@aspen/assets/images/ic_deposit@2x.png").default}
            alt=""
          />
        </span>
        {intl["home.deposit"]}
      </div>
      <div
        className={styles.entrance}
        onClick={() => {
          reportEvent({ moduleName: GA_EVENT_NAME.home.purchaseUSTD });
          router.push({
            pathname: YIELD_PATHS.YIELD_CREATE_DCA_PLAN,
          });
        }}>
        <span className={`${styles.quickIcon} ` + `pointerNone`}>
          <Image
            unoptimized
            src={require("@aspen/assets/images/ic_purchase@2x.png").default}
            alt=""
          />
        </span>
        {intl["home.deposit.fiat"]}
      </div>
      <div
        className={styles.entrance}
        onClick={() => {
          reportEvent({ moduleName: GA_EVENT_NAME.home.trade });
          handleClick(PUBLIC_PATHS.DOCUMENT_CENTER_PATH);
        }}>
        <span className={`${styles.quickIcon} ` + `pointerNone`}>
          <Image
            unoptimized
            src={require("@aspen/assets/images/ic_document.webp").default}
            alt=""
          />
        </span>
        {intl["document.title"]}
      </div>
      <EventEntranceView
        {...props}
        handleClick={route => {
          handleClick(route);
        }}
      />
    </div>
  );
};
export default memo(QuickEntranceView);
